'use strict';

import stringSimilarity from 'string-similarity';

angular.module('docketbook').
  controller('selectResourceController', function (xeroService, resourceService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $window, $q) {

    // Initialise variables to be used
    $scope.resourceCategorySearch = "";
    $scope.resourceSearch = "";
    $scope.resourceSearchLoading = false;
    $scope.resourceCategorySearchList = [];
    $scope.resourceCategorySearchListFull = [];
    $scope.resourceSearchCallback = null;
    $scope.resourceSelectState = 'category';
    $scope.listCount = 0;
    $scope.desktopSelected = [];
    $scope.searchText = null;
    $scope.allowedResourceCategories = [];
    $scope.allowedResourceCategoryIds = [];
    $scope.tableSettings = { multiple: true };
    $scope.preventLoad = false;
    $scope.filteredUoms = [];
    $scope.filteredCategories = [];

    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'name',
      categoryFilter: 'all'
    };

    $scope.cancelEdit = function (rowEdit, index) {
      if (rowEdit.id == null) {
        // If it's a new resource row simply remove the row
        $scope.resourceSearchList.splice(index, 1);
      } else {
        // Otherwise, refresh the data for the resource
        rowEdit.loading = true
        resourceService.getResources({ ids: [rowEdit.id] }, function (returnedObjs) {
          Object.assign(rowEdit, returnedObjs[0])
          rowEdit.loading = false;
          rowEdit.editing = false;
        }, function () {
          // fail
          rowEdit.loading = false;
        })
      }
    }

    /**********************************/
    /***** Secondary Data Models ******/
    /**********************************/

    $scope.allResourceCategories = [];
    $scope.sortedResourceCategories = {};
    $scope.allUoms = [];
    $scope.sortedUoms = {};

    $scope.getResourceCategories = function () {
      resourceService.getResourceCategories(null, function (categories) {
        $scope.allResourceCategories = categories;
        $scope.filteredCategories = categories;
      }, function (err) {
        $scope.allResourceCategories = [];
        $scope.filteredCategories = [];
      });
    }

    $scope.getUoms = function () {
      resourceService.getUoms(null, function (uoms) {
        $scope.allUoms = uoms;
        $scope.filteredUoms = uoms;
      }, function (err) {
        $scope.allUoms = [];
        $scope.filteredUoms = [];
      });
    }

    $scope.getResourceCategories();
    $scope.getUoms();


    // Edit resource table row
    $scope.editResourceRow = function (resourceRow) {
      resourceRow.editing = true;
      resourceRow.loading = false;
    }

    $scope.saveResourceRow = function (resourceRow, successCb) {
      var resourceSave = angular.copy(resourceRow);
      var valid = true;
      if (resourceRow.name == null || resourceRow.name == "") {
        valid = false;
      }
      if (resourceRow.identifier == null || resourceRow.identifier == "") {
        valid = false;
      }
      if (resourceRow.category == null) {
        valid = false;
      } else {
        resourceSave.category = resourceRow.category.id;
      }
      if (resourceRow.uom == null) {
        valid = false;
      } else {
        resourceSave.uom = resourceRow.uom.id;
      }
      resourceSave.name = resourceRow.name;
      resourceSave.identifier = resourceRow.identifier;

      if (!valid) {
        return false;
      }

      resourceRow.editing = false;
      resourceRow.loading = true;
      if (resourceRow.xeroID && resourceRow.id != null) {
        var existingXeroIdentifier = null;
        if (resourceRow.externalIdentifiers) {
          existingXeroIdentifier = resourceRow.externalIdentifiers.find(function (eid) {
            return eid.type === 'xero';
          });
        }
        if ((!resourceRow.externalIdentifiers) || (existingXeroIdentifier === undefined) || (existingXeroIdentifier === null) || (existingXeroIdentifier.externalId !== resourceRow.xeroID)) {
          resourceSave.externalIdentifiers = {
            add: [{
              type: 'xero',
              externalId: resourceRow.xeroID.externalId
            }]
          };
          if (existingXeroIdentifier !== undefined) {
            resourceSave.externalIdentifiers.delete = [existingXeroIdentifier];
          }
        }
      } else if (resourceRow.xeroID && resourceRow.id == null) {
        resourceSave.externalIdentifiers = [];
        resourceSave.externalIdentifiers.push({
          type: 'xero',
          externalId: resourceRow.xeroID.externalId
        });
      }
      resourceService.saveResource(resourceSave, function (updatedResource) {
        resourceRow.loading = false;
        if (successCb) {
          successCb(updatedResource)
        }
      }, function (err) {
        resourceRow.loading = false;
        $scope.alertService.presentAutoAlert('saveResource', err);
      });
    }

    $scope.searchUomChange = function (resource, searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredUoms = angular.copy($scope.allUoms);
      } else {
        $scope.filteredUoms = [];
        for (var i = 0; i < $scope.allUoms.length; i++) {
          if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 ||
            $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredUoms.push($scope.allUoms[i]);
          }
        }
      }
    }

    $scope.searchCategoryChange = function (resource, searchText) {
      if (searchText == null || searchText == "") {
        $scope.filteredCategories = angular.copy($scope.allResourceCategories);
      } else {
        $scope.filteredCategories = [];
        for (var i = 0; i < $scope.allResourceCategories.length; i++) {
          if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
            $scope.filteredCategories.push($scope.allResourceCategories[i]);
          }
        }
      }
    }

    $scope.categoryFilterChanged = function () {
      $scope.loadResourceList()
    }

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    /* For Desktop Specific */
    $scope.loadResourceList = function () {
      if ($scope.currentOrg == null || $scope.currentOrgGroup == null) {
        return;
      }
      $scope.promise = $q(function (resolve, reject) {
        var queryParams = {};
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
        if ($scope.searchText != null && $scope.searchText != "") {
          queryParams.search = $scope.searchText;
        }
        if ($scope.query.categoryFilter != 'all') {
          queryParams.categoryId = $scope.query.categoryFilter;
        }
        $scope.desktopSelected = [];
        resourceService.getResources(queryParams, function (returnObject) {
          var resourceList = returnObject;
          if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          $scope.resourceSearchList = [];
          if ($scope.allowedResourceCategories == null) {
            $scope.resourceSearchList = returnObject;
          } else {
            for (var i = 0; i < returnObject.length; i++) {
              var newResource = returnObject[i];

              for (var j = 0; j < $scope.allowedResourceCategories.length; j++) {
                var category = $scope.allowedResourceCategories[j];
                if (returnObject[i].categoryId == category.id) {
                  if (category.filterByOrder == true && $scope.desktopLineItems) {
                    for (var k = 0; k < $scope.desktopLineItems.length; k++) {
                      if ($scope.desktopLineItems[k].resource && $scope.desktopLineItems[k].resource.id == returnObject[i].id) {
                        newResource.orderItemId = $scope.desktopLineItems[k].id;
                        newResource.orderSupplierRef = $scope.desktopLineItems[k].supplierRef;
                        newResource.lineDescription = $scope.desktopLineItems[k].itemDescription;
                      }
                    }
                  }
                }
              }
              $scope.resourceSearchList.push(newResource);
            }
          }
          // populate item descriptions from order/job line items
          if ($scope.desktopLineItems) {
            for (var i = 0; i < $scope.desktopLineItems.length; i++) {
              for (var k = 0; k < $scope.resourceSearchList.length; k++) {
                if ($scope.desktopLineItems[i].resource && $scope.desktopLineItems[i].resource.id == $scope.resourceSearchList[k].id) {
                  $scope.resourceSearchList[k].lineDescription = $scope.desktopLineItems[i].itemDescription;
                  $scope.resourceSearchList[k].orderItemId = $scope.desktopLineItems[i].id;
                  $scope.resourceSearchList[k].orderSupplierRef = $scope.desktopLineItems[i].supplierRef;
                }
              }
            }
          }
          // Disabled any existing resources
          if ($scope.existingResources) {
            for (var i = 0; i < $scope.resourceSearchList.length; i++) {
              if ($scope.existingResources.indexOf($scope.resourceSearchList[i].id) != -1) {
                $scope.resourceSearchList[i].existing = true;
              }
            }
          }

          const externalIds =
            $scope.resourceSearchList
              .filter(resource => resource.externalIdentifiers != null)
              .map(resource =>
                resource.externalIdentifiers.find(identifier => identifier.type == 'xero')
              )
              .filter(identifier => identifier != undefined)
              .map(identifier => identifier.externalId)
              .join(',')

          if ($scope.currentOrg.features && $scope.currentOrg.features.xero /*&& $scope.currentOrg.features.xero.displayUnitPrices*/) {
            xeroService.getXeroItems({ externalIds }, function (xeroItems) {
              //for ( var i = 0; i < $scope.resourceSearchList.length; i++ ) {
              $scope.resourceSearchList
                .filter(resource => resource.externalIdentifiers != null)
                .forEach(resource => {
                  resource.externalIdentifiers
                    .filter(externalIdentifier => externalIdentifier.type == 'xero')
                    .map(externalIdentifier => externalIdentifier.externalId)
                    .forEach(externalId => {
                      xeroItems.forEach(xeroItem => {
                        if (externalId == xeroItem.externalId) {
                          resource.xeroItem = xeroItem
                        }
                      })
                    })

                  // find xero external id
                  /*var xeroExternalId = null;
                  //for ( var j = 0; j < $scope.resourceSearchList[i].externalIdentifiers.length; j++ ) {
                  const xeroIds = resource.externalIdentifiers.filter(externalId => externalId.type == 'xero')
                  if (xeroIds.length > 0) {
                    //if ( $scope.resourceSearchList[i].externalIdentifiers[j].type == 'xero' ) {
                      xeroExternalId = xeroIds[0]
                      //break;
                  }
                  var foundXeroItem = null;
                  if ( xeroExternalId ) {
                    //for ( var j = 0; j < items.length; j++ ) {
                    xeroItems.forEach(xeroItem => {
                      if ( xeroItem.id == xeroExternalId ) {
                        foundXeroItem = xeroItem;
                      }
                    })
                  }
                  if ( foundXeroItem ) {
                    $scope.resourceSearchList[i].xeroItem = foundXeroItem;
                  }*/
                })
            }, function (err) {
              console.error('could not get xero items', err);
            });

            resolve('Done');
          } else {
            resolve('Done');
          }
        }, function (err) {
          $scope.resourceSearchList = [];
          reject('Error');
        });
      });
    }

    $scope.searchResourceChange = function (searchText) {
      $scope.searchText = searchText;
      $scope.loadResourceList();
    }

    $scope.rowClick = function (resource) {
      if (!resource.editing) {

      }
    }

    $scope.$parent.desktopResourceSelectFromParent = function (options, cb) {
      $scope.orderLineItem = options.orderLineItem;
      var categoriesList = options.categories;
      $scope.existingResources = options.existingResources;
      if (categoriesList != null && categoriesList.length > 0) {
        $scope.allowedResourceCategories = categoriesList;
        $scope.allowedResourceCategoryIds = categoriesList.map(category => category.id);
      } else {
        $scope.allowedResourceCategories = null;
        $scope.allowedResourceCategoryIds = null;
      }
      $scope.desktopLineItems = options.lineItems;

      $scope.resourceSelectCallback = cb;
      $scope.resourceSearch = "";
      $scope.desktopSelected = [];
      if (options && options.multiple == false) {
        //TODO: implement single/multiselect mode changing
        $scope.tableSettings.multiple = false;
      } else {
        $scope.tableSettings.multiple = true;
      }
      $scope.query = {
        limit: 10,
        page: 1,
        order: 'name',
        categoryFilter: 'all'
      };
      $scope.loadResourceList(/*function() { $scope.orderListByDescriptionMatch()}*/);
      $("#selectResourceModal").fadeIn(100);
      $("input[name='selectResourceInput']").focus();
    }

    $scope.closeResourceSelectList = function () {
      $scope.searchResourceChange("");
      $("input[name='selectResourceInput']").val("");
      $scope.resourceSelectCallback(null);
      $("#selectResourceModal").fadeOut(100);
    }

    $scope.addNewResource = function () {
      var newResource = { name: "", identifier: "", editing: true };
      $scope.resourceSearchList.splice(0, 0, newResource);
      // Select the new resource row
      $scope.desktopSelected = [newResource]
    }

    $scope.desktopSelectResourceContinue = function () {
      if ($scope.desktopSelected[0].editing) {
        $scope.saveResourceRow($scope.desktopSelected[0], function (updatedResource) {
          $scope.resourceSelectCallback([updatedResource]);
          $("#selectResourceModal").fadeOut(100);
        })
      } else {
        $scope.resourceSelectCallback($scope.desktopSelected);
        $("#selectResourceModal").fadeOut(100);
      }
    }

    /* For Mobile */
    $scope.$parent.resourceSelectFromParent = function (options, cb) {
      $scope.resourceCategorySearch = "";
      $scope.resourceSelectCallback = cb;
      $scope.resourceCategorySearchList = options.categoriesList;
      $scope.resourceCategorySearchListFull = options.categoriesList;
      $scope.resourceSearchLoading = false;
      $scope.resourceSelectCategoryCount = 0;
      $scope.resourceSelectState = 'category';
      $scope.lineItems = options.lineItems;
      $scope.preventLoad = false;
      $scope.docketResources = options.docketResources;
    }

    $scope.categoryListBackPress = function () {
      $scope.resourceSelectCallback(null);
    }

    $scope.resourceListBackPress = function () {
      $scope.resourceSelectState = 'category';
    }

    $scope.mobileResourceSearch = function (searchText) {
      $scope.selectResourceCategory($scope.resourceCategorySelected, searchText);
    }

    $scope.selectResourceCategory = function (category, searchText) {
      if (searchText != null && searchText != "") {
        $scope.resourceSearch = searchText;
      } else {
        $scope.resourceSearch = "";
      }
      $scope.query.page = 1;
      $scope.resourceCategorySelected = category;
      $scope.resourceSelectState = 'resource';
      $scope.resourceSearchLoading = true;
      $scope.resourceSearchList = [];
      $scope.lastResourceSearchValue = searchText;
      var newResourceList = [];
      var lineResourceList = [];
      // add any resources by line items from order/job
      if ($scope.lineItems) {
        for (var i = 0; i < $scope.lineItems.length; i++) {
          if ($scope.lineItems[i].resource && $scope.lineItems[i].resource.category && $scope.lineItems[i].resource.category.id == category.id) {
            var thisResource = $scope.lineItems[i].resource;
            thisResource.lineDescription = $scope.lineItems[i].itemDescription;
            thisResource.orderItemId = $scope.lineItems[i].id;
            // check if this line has already been added to the docket
            var okToAdd = true;
            if ($scope.docketResources) {
              for (var j = 0; j < $scope.docketResources.length; j++) {
                if ($scope.docketResources[j].orderItemId == thisResource.orderItemId) {
                  okToAdd = false;
                  break;
                }
              }
            }
            if (okToAdd) {
              if (searchText != null && searchText != "" && (thisResource.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || thisResource.identifier.toLowerCase().indexOf(searchText.toLowerCase()) != -1)) {
                lineResourceList.push(thisResource);
              } else if (searchText == null || searchText == "") {
                lineResourceList.push(thisResource);
              }
            }
          }
        }
      }

      // Get resources for category if filterByOrder not required
      if (category.filterByOrder != true) {
        $scope.getMobileResourcesList(category, searchText, function (resources) {
          for (var i = 0; i < resources.length; i++) {
            newResourceList.push(resources[i]);
            for (var j = 0; j < lineResourceList.length; j++) {
              if (lineResourceList[j].id == resources[i].id) {
                newResourceList.push(lineResourceList[j]);
                break;
              }
            }
          }
          $scope.resourceSearchList = newResourceList;
          $scope.resourceSearchLoading = false;
        }, function (err) {
          alert('Error getting resources');
          if (newResourceList.length > 0) {
            $scope.resourceSearchList = newResourceList;
            $scope.resourceSearchLoading = false;
          } else {
            $scope.resourceSearchLoading = false;
            $scope.resourceLoadingError = "Error Loading Resources";
          }
        });
      } else {
        $scope.resourceSearchList = lineResourceList;
        $scope.resourceSearchLoading = false;
      }
    }

    $scope.assignResourceToItem = function (resource) {
      $scope.resourceSelectCallback(resource);
    }

    $scope.getMobileResourcesList = function (category, searchText, successCb, failureCb) {
      $scope.preventLoad = false;
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      if (category && category.id) {
        queryParams.categoryId = category.id;
      }
      if (searchText != null && searchText != "") {
        queryParams.search = searchText;
      }
      resourceService.getResources(queryParams, function (returnObject) {
        var resourceList = [];
        resourceList = returnObject;
        if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        successCb(resourceList);
      }, function (err) {
        failureCb(err);
      });
    }

    $scope.loadNextPageOfResources = function (cb) {
      $scope.query.page += 1;
      $scope.getMobileResourcesList($scope.resourceCategorySelected, $scope.lastResourceSearchValue, function (resources) {
        if (resources.length == 0) {
          $scope.preventLoad = true;
        }
        for (var i = 0; i < resources.length; i++) {
          $scope.resourceSearchList.push(resources[i]);
        }
        cb();
      }, function (err) {
        cb();
      });
    }

    $scope.loadingMoreItems = false;
    $scope.resourcesListLoadingCount = 0;
    angular.element($window).on('scroll', function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
        var offset = $scope.query.limit * ($scope.query.page - 1);
        if (!$scope.loadingMoreItems && !$scope.preventLoad) {
          $scope.loadingMoreItems = true;
          $("#resourcesLoadingMore").removeClass('hidden');
          $scope.loadNextPageOfResources(function () {
            $scope.loadingMoreItems = false;
            $("#resourcesLoadingMore").addClass("hidden");
          });
        }
      }
    });

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.updateResourceCategorySearch = function (searchValue) {
      var categories = $scope.resourceCategorySearchListFull;
      if (searchValue === "") {
        $scope.resourceCategorySearchList = categories;
        return;
      }

      var filteredList = [];
      for (var key in categories) {
        if (categories[key].name.indexOf(searchValue) != -1) {
          filteredList.push(categories[key]);
        }
      }

      $scope.resourceCategorySearchList = filteredList;
      return;
    }

    $scope.updateResourceSearch = function (searchValue) {
      $scope.selectResourceCategory($scope.resourceCategorySelected, searchValue);
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectResourceController.js